<script>
  import { Bar } from 'vue-chartjs'

  export default {
    name: 'StatChart',
    extends: Bar,
    props: ['monthlyStats'],
    data () {
      return {

      }
    },
    methods: {
      createChart () {
        let labels = [];
        let data = [];

        for (let i in this.monthlyStats) {
          labels.unshift(i);
          data.unshift(this.monthlyStats[i]);
        }

        this.renderChart({
          labels,
          datasets: [
            {
              label: 'Number of requests',
              backgroundColor: '#67C23A',
              data
            }
          ],
        }, {
          maintainAspectRatio: false,
          title: {
            text: 'Number of requests in 12 months',
            display: true,
          },
          legend: {
            display: false,
          },
          scales: {
            xAxes: [{
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              }
            }]
          }
        })
      }
    },
    mounted () {
      this.createChart();
    },
    watch: {
      monthlyStats () {
        this.createChart();
      }
    }
  }
</script>